import React from 'react'
import { zivaLogo_Image } from '../../constants/imageConstants'

const ErrorPage = ({ error, resetErrorBoundary }) => {
  return (
    <div className='flex justify-center gap-3 items-center flex-col h-screen'>
      <img src={zivaLogo_Image} className='w-48 object-contain' alt="logo" />
      <p className="sm:text-4xl text-2xl text-center">Oops, Something went wrong!</p>
      <button onClick={resetErrorBoundary} className="hover:bg-main px-4 hover:text-white py-2 text-main border border-main transitions">
        Go back
      </button>
    </div>
  )
}

export default ErrorPage